import { PortableTextBlock } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';

import { ISanityImage } from 'typescriptDefs';

import generateBlogPathname from 'helpers/generateBlogPathname';

import CustomPortableText from './CustomPortableText';
import { LocaleContext } from './Layout';
import { Link } from './Link';

type Props = {
  excerpt: PortableTextBlock | PortableTextBlock[];
  img: { url?: string } | ISanityImage;
  imgAltText: string;
  minutesToRead: number;
  slug: {
    current: string;
  };
  subfolder?: string;
  title: string;
};

export const ArticleCard = ({ excerpt, img, imgAltText, minutesToRead, slug, subfolder, title }: Props) => {
  const locale = useContext(LocaleContext);
  const blogUrl = generateBlogPathname({ slug, subfolder, locale });

  return (
    <div className="flex-1">
      {img.url ? (
        <Link href={blogUrl}>
          <img
            className="mb-20 h-205 w-full rounded-12 object-cover md:h-240 md:rounded-16"
            src={img.url}
            alt={imgAltText}
          />
        </Link>
      ) : img['asset'] ? (
        <GatsbyImage
          className="mb-20 h-205 w-full rounded-12 object-cover md:h-240 md:rounded-16"
          image={(img as ISanityImage).asset.gatsbyImageData}
          alt=""
        />
      ) : null}
      <p className="mb-8 text-sm text-grey-350">
        {
          {
            en: `${minutesToRead} min read`,
            fr: `Lecture de ${minutesToRead} minutes`,
          }[locale]
        }
      </p>
      <Link className="mb-8 block text-3xl font-medium" aria-label={title} href={blogUrl}>
        <div className="line-clamp-2 text-ellipsis leading-134 text-grey-450">{title}</div>
      </Link>
      <div className="text-grey-350 [&>*]:line-clamp-2 [&>*]:text-ellipsis [&>*]:text-md">
        <CustomPortableText content={excerpt} />
      </div>
    </div>
  );
};
